import { createI18n } from 'vue-i18n'
import en from './locales/en'
import fr from './locales/fr'
import de from './locales/de'
import it from './locales/it'
import pt from './locales/pt'
import es from './locales/es'
import uk from './locales/uk'

const savedLocale = localStorage.getItem('locale') || 'en'

export const i18n = createI18n({
  legacy: false,
  locale: savedLocale,
  fallbackLocale: 'en',
  messages: { en, fr, de, it, pt, es, uk },
  pluralRules: {
    uk: (choice) => {
      if (choice === 0) return 2
      const mod10 = choice % 10
      const mod100 = choice % 100
      if (mod10 === 1 && mod100 !== 11) return 0
      if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return 1
      return 2
    },
  },
})
